import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import UserContext from "../../utils/user-context";
import { withApi } from "../../apis";
import SampleVoucherEmail from "../../images/sample-evoucher-email.png";
import SampleVoucherMobile from "../../images/sample-evoucher-mobile.png";
import Spinner from 'react-spinners/BeatLoader';
import validator from '../../utils/validations';
import { isMobile, isTablet } from "react-device-detect";

import Cookie from "universal-cookie";

import "./index.scss";

const cookie = new Cookie();

class LoginPage extends Component {
  static propTypes = {
    api: PropTypes.objectOf(PropTypes.any).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  static contextType = UserContext;

  static validate(field, value, callback) {
    if (field === "evoucherNumber") {
      if (!value || value.trim() === "") {
        if (callback) {
          callback({
            evoucherNumberError: "Enter e-voucher number",
            evoucherNumberHasError: true,
          });
        }
        return false;
      }

      if (callback) {
        callback({
          evoucherNumberError: "",
          evoucherNumberHasError: false,
        });
      }
      return true;
    }

    if (field === "companyName") {
      if (!value || value.trim() === "") {
        if (callback) {
          callback({
            companyNameError: "Enter company name",
            companyNameHasError: true,
          });
        }
        return false;
      }

      if (callback) {
        callback({
          companyNameError: "",
          companyNameHasError: false,
        });
      }

      return true;
    }
    return false;
  }

  state = {
    evoucherNumber: "",
    evoucherNumberError: "",
    evoucherNumberHasError: false,
    companyName: "",
    companyNameError: "",
    companyNameHasError: false,
    isLoading: false,
    responseError: "",
    submitCounter: 0,
  };

  constructor(props) {
    super(props);
    this.proceed = this.proceed.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.voucherNoRef = React.createRef();
    this.companyNameRef = React.createRef();

    cookie.remove("authorization");
  }

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const company = query.get("company");
    const number = query.get("number");
    if (company) {
      this.setState({
        companyName: company,
      });
    }
    if (number) {
      this.setState({
        evoucherNumber: number,
      });
    }
    const { setUserContext } = this.context;
    setUserContext({
      authenticated: false,
      evoucherNo: "",
    });
  }

  handleChange({ target }) {
    const { name, value } = target;
    const { submitCounter } = this.state;

    if (value === '') {
      this.setState({
        [name]: "",
      });
    }
    
    if (["evoucherNumber"].includes(name)) {
      const valid = validator.isValidString(value, "èéēÈÉĒ")
      if (valid) {
        if (submitCounter < 1) {
          this.setState({
            [name]: value,
          });
          return;
        }
         LoginPage.validate(name, value, (errorState) =>
         this.setState({
           ...errorState,
           responseError: "",
           [name]: value,
         })
        );
      }
    } else {
      if (submitCounter < 1) {
        this.setState({
          [name]: value,
        });
        return;
      }
       LoginPage.validate(name, value, (errorState) =>
       this.setState({
         ...errorState,
         responseError: "",
         [name]: value,
       })
      );
    }
  }

  async proceed() {
    const { api } = this.props;
    const { evoucherNumber, companyName } = this.state;
    this.setState({ isLoading: true })

    let hasError = false;

    const errorStateCallback = (errorState) => this.setState({ ...errorState });

    if (!LoginPage.validate("companyName", companyName, errorStateCallback)) {
      this.companyNameRef.current.focus();
      hasError = true;
    }

    if (
      !LoginPage.validate("evoucherNumber", evoucherNumber, errorStateCallback)
    ) {
      this.voucherNoRef.current.focus();
      hasError = true;
    }

    if (hasError) {
      this.setState(({ submitCounter }) => ({
        submitCounter: submitCounter + 1,
      }));

      this.setState({ isLoading: false })
      return;
    }

    const response = await api.peme.PostMethod("/self-service/sign-in", {
      evoucher_no: evoucherNumber,
      company_name: companyName,
    });

    const { data } = response;

    if (data.errors) {
      if (data.errors.company_name) {
        this.setState(({ submitCounter }) => ({
          submitCounter: submitCounter + 1,
          responseError: "E-voucher number or company is invalid",
        }));
      } else {
        this.setState(({ submitCounter }) => ({
          submitCounter: submitCounter + 1,
          responseError: data.errors.evoucher_no,
        }));
      }

      this.setState({ isLoading: false })
      this.voucherNoRef.current.focus();
    } else {
      const { history } = this.props;
      const { setUserContext } = this.context;
      setUserContext({
        authenticated: true,
        evoucherNo: data.evoucher_no,
        evoucherStatus: data.status,
        eselectedFacility: data.facility_code,
        coverage: data.coverage,
        memberId: data.member_id,
      });
      this.setState({ isLoading: false })
      cookie.set("authorization", data.token);
      history.push(`/applicant-details`);
    }
  }

  renderMobileContent = () => {
    const {
      evoucherNumber,
      companyName,
      evoucherNumberError,
      companyNameError,
      companyNameHasError,
      evoucherNumberHasError,
      responseError,
    } = this.state;

    let details = navigator.userAgent;
    let regexp = /iphone|kindle|ipad/i;
    let isIOSMobileDevice = regexp.test(details);
    return (
      <div class="row flex-column-reverse flex-md-row justify-content-md-center">
        <div class="col">
          <div className="d-flex justify-content-center card animated fadeIn">
            <p>
              <h3>Register your e-voucher</h3>
            </p>
            <small htmlFor="evoucherNote" className="mb-4 font-weight-light">
              Note: Your HR officer have sent your e-voucher details to your
              email or mobile number. <br />
              Kindly register your e-voucher on the day of your confirmed appointment with the clinic.
            </small>
            <small htmlFor="evoucherNote" className="mb-4 font-weight-light">
              Kindly register your e-voucher on the day of your confirmed appointment with the clinic.
            </small>
            <div class="sample-vouchers">
              <div class="sample-vouchers-email">
                <img
                  src={SampleVoucherEmail}
                  alt="voucher"
                  className={`img-fluid border ${isIOSMobileDevice ? 'ios-device' : ''}`}
                />
                <small>Sample e-voucher sent through email</small>
              </div>
              <div class="sample-vouchers-mobile">
                <img
                  src={SampleVoucherMobile}
                  alt="voucher"
                  className={`img-fluid border ${isIOSMobileDevice ? 'ios-device' : ''}`}
                />
                <small>Sample e-voucher sent through mobile</small>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="evoucherNumber">
                E-voucher Number
                <input
                  type="text"
                  className={`form-control${evoucherNumberHasError || responseError !== ""
                    ? " text-error"
                    : ""
                    }`}
                  name="evoucherNumber"
                  aria-describedby="voucherEntry"
                  placeholder="Enter e-voucher number"
                  maxLength="9"
                  onChange={this.handleChange}
                  value={evoucherNumber}
                  ref={this.voucherNoRef}
                />
                {evoucherNumberHasError && <small className="error-message">{evoucherNumberError}</small>}
              </label>
            </div>
            <div className="form-group">
              <label htmlFor="companyName">
                Company Name
                <input
                  type="text"
                  className={`form-control${companyNameHasError || responseError !== ""
                    ? " text-error"
                    : ""
                    }`}
                  name="companyName"
                  aria-describedby="companyNameEntry"
                  placeholder="Enter company name"
                  maxLength="255"
                  onChange={this.handleChange}
                  value={companyName}
                  ref={this.companyNameRef}
                />
                {companyNameHasError && <small className="error-message">{companyNameError}</small>}
              </label>
            </div>
            {
              responseError &&
              <div className="d-flex justify-content-center response-error-message">
                <small className="error-message">{responseError}</small>
              </div>
            }
            <div className="d-flex justify-content-center mb-3">
              <button
                type="button"
                className="btn btn-primary proceed"
                onClick={this.proceed}
              >
                Proceed
              </button>
            </div>
            <div className={isTablet || isMobile ? "text-center" : "text-left"}>
              <div class="reprint-label">{"Is your Letter of Authorization (LOA) missing? "}
                <Link to="/reprint-loa" className="reprint-link">
                  Reprint
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderBrowserContent = () => {
    const {
      evoucherNumber,
      companyName,
      evoucherNumberError,
      companyNameError,
      companyNameHasError,
      evoucherNumberHasError,
      responseError,
      isLoading,
    } = this.state;
    return (
      <div class="row flex-column-reverse flex-md-row justify-content-md-center">
        <div class="col d-flex">
          <div className="d-flex justify-content-center card animated fadeIn">
            <p>
              <h2>Register your e-voucher</h2>
            </p>
            <small htmlFor="evoucherNote" className="mb-4 font-weight-light">
              Note: Your HR officer have sent your e-voucher details to your email or mobile number. <br />
              Kindly register your e-voucher on the day of your confirmed appointment with the clinic.
            </small>

            <div className="form-group">
              <div htmlFor="evoucherNumber">
                E-voucher Number
                <input
                  type="text"
                  className={`form-control${evoucherNumberHasError || responseError !== ""
                    ? " text-error"
                    : ""
                    }`}
                  name="evoucherNumber"
                  aria-describedby="voucherEntry"
                  placeholder="Enter e-voucher number"
                  maxLength="9"
                  onChange={this.handleChange}
                  value={evoucherNumber}
                  ref={this.voucherNoRef}
                />
                {evoucherNumberHasError && <small className="error-message">{evoucherNumberError}</small>}
              </div>
            </div>
            <div className="form-group">
              <div htmlFor="companyName">
                Company Name
                <input
                  type="text"
                  className={`form-control${companyNameHasError || responseError !== ""
                    ? " text-error"
                    : ""
                    }`}
                  name="companyName"
                  aria-describedby="companyNameEntry"
                  placeholder="Enter company name"
                  maxLength="255"
                  onChange={this.handleChange}
                  value={companyName}
                  ref={this.companyNameRef}
                />
                {companyNameHasError && <small className="error-message">{companyNameError}</small>}
              </div>
            </div>

            {responseError &&
              <div className="d-flex justify-content-center response-error-message">
                <small className="error-message">{responseError}</small>
              </div>
            }

            {isLoading ?
              <div className="d-flex justify-content-center mb-3">
                <button class="btn btn-primary proceed" type="button">
                  <Spinner />
                </button>
              </div>
              :
              <div className="d-flex justify-content-center mb-3">
                <button
                  type="button"
                  className="btn btn-primary proceed"
                  onClick={this.proceed}
                >
                  Proceed
                </button>
              </div>
            }

            <div>
              {"Is your Letter of Authorization (LOA) missing? "}
              <Link to="/reprint-loa">
                Reprint
              </Link>
            </div>
          </div>
        </div>
        <div class="col card">
          <div class="row">
            <div class="col-7 col-md-12 mb-2">
              <img
                src={SampleVoucherEmail}
                alt="voucher"
                className="img-fluid border shadow w-75"
              />
              <small className="d-inline-block">Sample e-voucher sent through email</small>
            </div>
            <div class="col col-md-12 mb-2">
              <img
                src={SampleVoucherMobile}
                alt="voucher"
                className="img-fluid border shadow w-75"
              />
              <small className="d-inline-block">Sample e-voucher sent through mobile</small>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="signin-form-wrapper container h-100">
        <div className="row h-100 min-vh-100 justify-content-center align-items-center">
          {isMobile || isTablet ? this.renderMobileContent() : this.renderBrowserContent()}
        </div>
      </div>
    );
  }
}

export default withRouter(withApi(LoginPage));
